<template>
  <div>
    <slot>
      <q-btn flat dense round icon="account_box" @click="isModalOpen = true"></q-btn>
    </slot>
    <q-modal v-model="isModalOpen" content-classes="q-pa-lg" content-css="min-width: 70%">
      <div class="row q-pb-md">
        <div class="col-10">
          <span class="text-primary q-title">Account Info</span>
        </div>
        <div class="col-2 text-right"></div>
      </div>
      <form @submit.prevent="submit" v-if="isModalOpen">
        <user-edit :account-modal="true" :user="user"></user-edit>
      </form>
      <div class="q-pt-lg q-pb-lg row gutter-xl items-end">
        <div class="col-4 text-right">
          <q-btn
            color="warning"
            type="button"
            label="Cancel / Close"
            class="no-shadow block"
            flat
            @click="handleCancel"
          />
        </div>
      </div>
    </q-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import colors from '../mixins/colors'
import UserEdit from '../components/custom/userEdit'

export default {
  inject: ['$validator'],
  mixins: [colors],
  name: 'accountModal',
  components: { UserEdit },
  props: {
    value: {
      type: Object
    },
    modalOpenInit: {
      type: Boolean,
      default: false
    },
    newUser: {
      type: Boolean,
      default: false
    },
    syncRoles: {
      type: Array,
      default: () => []
    },
    layout: {
      type: String,
      default: () => 'icon'
    }
  },
  data () {
    return {
      // ready: false,
      loading: false,
      isModalOpen: this.modalOpenInit,
      changePassword: false,
      form: {
        name: '',
        username: '',
        email: '',
        password: '',
        passwordConfirmation: ''
      }
    }
  },
  created () {
    if (this.value) {
      this.form.name = this.value.name
      this.form.username = this.value.username
      this.form.email = this.value.email
    }
  },
  computed: {
    ...mapGetters('auth', ['user']),
    passwordValidation () {
      if (this.changePassword) {
        return {
          required: true,
          is: this.form.password
        }
      }
      return {}
    },
    passwordConfirmationValidation () {
      if (this.changePassword) {
        return {
          required: true,
          min: 6
        }
      }
      return {}
    }
  },
  methods: {
    handleCancel () {
      this.isModalOpen = false
    },
    handleCancelPassword () {
      this.changePassword = false
      this.form.password = ''
      this.form.passwordConfirmation = ''
    },
    async submit () {
      // console.log(this.$validator)
      const result = await this.$validator.validate('accountModal.*')
      if (!result) {
        this.$q.notify({
          message: 'Please complete all required fields',
          type: 'negative'
        })
        return
      }
      const model = {
        name: this.form.name,
        username: this.form.username,
        email: this.form.email,
        password: this.form.password,
        passwordConfirmation: this.form.passwordConfirmation,
        roles: this.syncRoles && this.syncRoles.length ? this.syncRoles : null
      }
      try {
        this.loading = true
        // const {data} = await this.$axios.post('/users/update/' + this.user.id, model)
        // const {data} = await this.$axios.post('/users/' + this.user.id + '/update', model)
        // const {data} = await this.$axios.post('/users/' + this.user.id, model)
        let method = 'post'
        let url = '/users'
        if (this.value && this.value.id) {
          url = `${url}/${this.value.id}`
          method = 'put'
        }
        const { data } = await this.$axios[method](url, model)
        this.$q.notify({
          message: 'User account has been updated',
          type: 'positive'
        })
        this.$emit('input', data)
        this.loading = false
        this.handleCancel()
      } catch (e) {
        // console.log(e)
        this.loading = false
        this.$q.notify({
          message: `Error processing update`
        })
      }
    }
  },
  watch: {
    modalOpenInit (v) {
      this.isModalOpen = v
    }
  }
}
</script>

<style scoped>
</style>
